import { Reveal } from "@/components/common/Reveal";
import BeforeAfterSlider from "./BeforeAfterSlider";

const CHAPTERS = [
  {
    n: "01",
    title: "We come to you",
    body: "No lineups, no drop-offs, no wasted Saturdays. Our crew rolls up to your driveway or office and turns your car into the best part of your day.",
    img: "/gallery/img_6291.webp",
  },
  {
    n: "02",
    title: "Detail obsessed",
    body: "Every panel, every seam, every stitch. We treat your car the way a jeweller treats a diamond — because the details are what you feel every time you drive. Drag the slider to see this Porsche Cayenne go from daily-driver to showroom.",
    before: "/gallery/img_7024.webp",
    after: "/gallery/img_7038.webp",
  },
  {
    n: "03",
    title: "Drive away proud",
    body: "That first turn out of the driveway in a freshly detailed car? Pure confidence. That feeling is the whole point — and it's waiting for you tonight.",
    img: "/gallery/img_7034.webp",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="relative bg-white">
      <div className="container-rv py-24 lg:py-32">
        <Reveal className="mb-16 max-w-2xl">
          <p className="overline text-brand-red">The Reverence way</p>
          <h2 className="mt-4 font-serif text-4xl font-bold leading-tight text-brand-charcoal sm:text-5xl">
            More than a wash.<br />A feeling you can drive.
          </h2>
        </Reveal>

        <div className="space-y-20 lg:space-y-28">
          {CHAPTERS.map((c, i) => (
            <div
              key={c.n}
              className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-20 ${i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""}`}
            >
              <Reveal y={40}>
                <div className="flex items-baseline gap-5">
                  <span className="font-serif text-6xl font-bold chrome-text sm:text-7xl">{c.n}</span>
                  <div className="h-px flex-1 bg-brand-silver/40" />
                </div>
                <h3 className="mt-6 font-serif text-3xl font-bold text-brand-charcoal sm:text-4xl">{c.title}</h3>
                <p className="mt-5 max-w-md text-brand-muted leading-relaxed">{c.body}</p>
              </Reveal>

              <Reveal y={40} delay={0.1}>
                {c.before ? (
                  <BeforeAfterSlider before={c.before} after={c.after} alt={c.title} />
                ) : (
                  <div className="group relative overflow-hidden rounded-2xl border border-brand-silver/40">
                    <img
                      src={c.img}
                      alt={c.title}
                      className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-brand-charcoal/25 to-transparent" />
                  </div>
                )}
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
